var swiper = new Swiper(".content-list-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    1199: {
      slidesPerView: 5, 
      spaceBetween: 10,  
    },
    990: {
      slidesPerView: 4, 
      spaceBetween: 10,  
    },
    750: {
      slidesPerView: 3, 
      spaceBetween: 10,  
    },
    0: {
      slidesPerView: 1.2, 
      spaceBetween: 10,  
    },
  },
});
